import Model from './model.js'

export default {
  Read: function(params) {
    let cluster = params.self.props.Cluster;
    if(params.action === 'Next') {
      params.data.url = params.self.state.nextPage;
    }

    if(cluster === 'all-booking') {
      params.data.status = 'all';

    } else if(cluster === 'future-booking') {
      params.data.status = 'future';

    } else if(cluster === 'past-booking'){
      params.data.status = 'past';

    } else {
      params.data.status = 'started';
    }
    Model.Read(params);
  }
}


// WEBPACK FOOTER //
// ./src/App/booking/presenter.js